import { useMemo } from 'react';
import { CampaignAdminDto } from '../../../services/Campaign/campaignService.dto';
import { campaignService } from '../../../services/Campaign/campaignService';
import { useBackendData } from '../../../services/useBackendData';

export const useCampaignDetails = (campaignId?: number, campaignData?: CampaignAdminDto) => {
  const { data: campaign, isLoading } = useBackendData({
    queryKey: ['campaign', campaignId],
    queryFn: () => campaignService.fetchSingleCampaign(campaignId!),
    enabled: !campaignData && !!campaignId,
    initialData: campaignData,
  });

  const info = useMemo(() => (!!campaign ? `${campaign.name} (#${campaign.id})` : ''), [campaign]);

  return { campaign, isLoading, info };
};
